import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
    IOLinesMode,
} from '@appblocks/codegeneration/types';
import KeypadNode from '@appblocks/codegeneration/Nodes/KeypadNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class KeypadReleasedNode extends KeypadNode {
    constructor() {
        super();
        this.name = 'On Button Released';
        this.id = 'node_keypad_released';
        this.linkedFeature = 'general';
        this.icon = 'RxButton';
        this.key_event = 'PL_KP_EVENT_RELEASED';
        this.outputs = [
            {
                name: 'Button Released',
                portId: 'on_kp_released',
                params: [],
            },
        ];
    }
}
